import React from 'react';
import './SectionLabel.css';

const SectionLabel = ({ children, icon, variant = 'default' }) => {
  return (
    <div className={`section-label ${variant ? `section-label--${variant}` : ''}`}>
      {icon && <span className="section-label-icon">{icon}</span>}
      <span className="section-label-text">{children}</span>
    </div>
  );
};

export default SectionLabel;
